import { CHIPS_COLORS } from './colors';
import { ChipType } from '../types';
import { chipsMAX1 } from './chipsValues';

export const CHIPS_MIN_1: ChipType[] = [
  {
    color: CHIPS_COLORS.BLUE,
    value: 1,
  },
  {
    color: CHIPS_COLORS.YELLOW,
    value: 2,
  },
  {
    color: CHIPS_COLORS.RED,
    value: 5,
  },
  {
    color: CHIPS_COLORS.VIOLET,
    value: 10,
  },
  {
    color: CHIPS_COLORS.GREEN,
    value: 20,
  },
  {
    color: CHIPS_COLORS.ORANGE,
    value: 50,
  },
  {
    color: CHIPS_COLORS.LIGHT_BLUE,
    value: 100,
  },
  {
    color: CHIPS_COLORS.SCARLET,
    value: 500,
  },
  {
    color: CHIPS_COLORS.PURPLE,
    value: 1e3,
  },
  {
    color: CHIPS_COLORS.LIGHT_GREEN,
    value: 2e3,
  },
  ...chipsMAX1,
];
